import { render, staticRenderFns } from "./ContactLink.vue?vue&type=template&id=27e2cc0c&"
import script from "./ContactLink.vue?vue&type=script&lang=ts&"
export * from "./ContactLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports